<form class="container" [formGroup]="form" autocomplete="off" (ngSubmit)="confirmar()" data-test="modal-autorizar-acesso">
    <div class="header">
        <div class="header-icon">
            <i class="material-icons">admin_panel_settings</i>
        </div>
        <h2 class="header-title" data-test="titulo-modal-autorizar-acesso">{{ 'accessApproval.title' | translate }}</h2>
        <button mat-icon-button color="primary" type="button" class="close-button"
            [disabled]="carregando"
            [attr.aria-label]="'accessApproval.cancel' | translate"
            data-test="btn-fechar-modal-autorizar-acesso"
            (click)="cancelar()">
            <i class="material-icons">close</i>
        </button>
    </div>

    <!-- Qual funcionalidade abriu o modal e, no "?", onde alterar a ação dela -->
    <div class="feature-row" *ngIf="funcionalidade">
        <span class="feature-label" data-test="texto-funcionalidade-autorizar-acesso">{{ funcionalidade }}</span><button type="button" class="help-button" (click)="abrirAjuda()"
            [attr.aria-label]="'accessApproval.helpButton' | translate"
            [matTooltip]="'accessApproval.helpButton' | translate"
            data-test="btn-ajuda-onde-alterar-autorizacao">
            <mat-icon>help_outline</mat-icon>
        </button>
    </div>

    <fieldset class="fieldset" [disabled]="carregando">
        <mat-dialog-content class="content">
            <div *ngIf="unicoUsuario === null && !erroAoCarregar" class="loading" data-test="msg-carregando-autorizar-acesso">
                <mat-spinner diameter="32"></mat-spinner>
            </div>

            <!-- Falha ao saber se a conta tem um ou vários usuários: sem campos e sem autorização -->
            <div class="inactive-account" *ngIf="erroAoCarregar" data-test="msg-erro-carregar-autorizar-acesso">{{ 'accessApproval.validationError' | translate }}</div>

            <ng-container *ngIf="unicoUsuario !== null">
                <app-auth-credentials-fields [form]="form" [email]="email" [mostrarOpcoes]="mostrarOpcoes"></app-auth-credentials-fields>

                <div class="inactive-account" *ngIf="erro" data-test="msg-erro-autorizar-acesso">{{ erro }}</div>
            </ng-container>
        </mat-dialog-content>

        <div class="actions">
            <button mat-stroked-button color="primary" type="button" [disabled]="carregando" data-test="btn-cancelar-autorizar-acesso" (click)="cancelar()">
                {{ 'accessApproval.cancel' | translate }}
            </button>
            <button *ngIf="!erroAoCarregar" mat-raised-button color="primary" type="submit" class="button" [disabled]="esgotado" data-test="btn-confirmar-autorizar-acesso">
                <!-- Durante a validação e a espera de 2 segundos o texto some e o spinner fica no meio; depois o texto volta -->
                <mat-spinner *ngIf="carregando" class="button-spinner" diameter="18"></mat-spinner>
                <span [class.button-text-hidden]="carregando">{{ 'accessApproval.confirm' | translate }}</span>
            </button>
            <button *ngIf="erroAoCarregar" mat-raised-button color="primary" type="button" class="button" data-test="btn-tentar-novamente-autorizar-acesso" (click)="carregarOpcoes()">
                {{ 'accessApproval.retry' | translate }}
            </button>
        </div>
    </fieldset>
</form>
